export default "__VITE_ASSET__b9b71c8a__"